"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ratingValueChecked = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const typography_1 = require("../../shared/typography");
const icons_1 = require("../../atoms/icons");
const mark_boolean_value_1 = require("../../molecules/mark-boolean-value");
const ratingValueChecked = (value) => value === "null" || value === "" || value === null ? "-" : `${value}`;
exports.ratingValueChecked = ratingValueChecked;
exports.default = ({ trainingsTitle, trainingsValue, ratingTitle, ratingValue, activitiesTitle, activitiesValue, isDay = false, isTrainingDay = false }) => {
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(typography_1.H4, { children: trainingsTitle }, void 0), isDay ? (isTrainingDay && (0, jsx_runtime_1.jsx)(mark_boolean_value_1.MarkBooleanValue, { value: trainingsValue }, void 0)) : ((0, jsx_runtime_1.jsx)(typography_1.P, { children: trainingsValue }, void 0))] }, void 0), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(typography_1.H4, { children: ratingTitle }, void 0), isDay ? (isTrainingDay && ((0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangle", color: "light-grey", children: (0, exports.ratingValueChecked)(ratingValue) }, void 0))) : ((0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "rectangle", color: "light-grey", children: (0, exports.ratingValueChecked)(ratingValue) }, void 0))] }, void 0), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(typography_1.H4, { children: activitiesTitle }, void 0), (0, jsx_runtime_1.jsx)(typography_1.P, { children: activitiesValue }, void 0)] }, void 0)] }, void 0));
};
const Wrapper = styled_components_1.default.div `
  background-color: ${({ theme }) => theme.colors.whiteBase};
  border: 1px solid ${({ theme }) => theme.colors.silverBase};
  border-radius: ${({ theme }) => theme.utils.radius};
  display: flex;
  width: 100%;

  h4,
  p {
    letter-spacing: -0.17px;
    line-height: 1.5rem;
    margin-bottom: 0;
  }

  h4 {
    font-weight: 500;
    padding-right: ${({ theme }) => theme.spacings.xxs};
  }

  p {
    transform: translateY(2px);
  }

  & > div:not(:last-of-type) {
    border-right: 1px solid ${({ theme }) => theme.colors.silverBase};
  }

  & > div {
    display: flex;
    flex: 1;
    justify-content: space-between;
    padding: ${({ theme }) => `${theme.spacings.s} ${theme.spacings.xl}`};

    p {
      color: ${({ theme }) => theme.colors.greyBase};
    }
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    background-color: transparent;
    border: none;
    flex-direction: column;

    p {
      transform: translateY(0);
    }

    & > div {
      background-color: ${({ theme }) => theme.colors.whiteBase};
      border-bottom: 1px solid ${({ theme }) => theme.colors.silverBase};
      border-top: 1px solid ${({ theme }) => theme.colors.silverBase};
      margin-bottom: ${({ theme }) => theme.spacings.xs};
      padding: ${({ theme }) => `${theme.spacings.s} ${theme.spacings.m}`};
    }

    & > div:last-of-type p {
      font-weight: 400;
      text-align: center;
      width: ${({ theme }) => theme.spacings.xl};
    }
  }
`;
//# sourceMappingURL=TrainingInfoBar.js.map